import { Stack, Text, Title, Button, Center } from '@mantine/core';
import { IconPlus, IconSearch } from '@tabler/icons-react';

interface EmptyStateProps {
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ReactNode;
  };
  icon?: 'search' | 'add' | 'custom';
  customIcon?: React.ReactNode;
}

export function EmptyState({
  title,
  description,
  action,
  icon = 'search',
  customIcon,
}: EmptyStateProps) {
  const getIcon = () => {
    if (customIcon) return customIcon;
    switch (icon) {
      case 'search':
        return <IconSearch size={48} stroke={1.5} />;
      case 'add':
        return <IconPlus size={48} stroke={1.5} />;
      default:
        return null;
    }
  };

  return (
    <Center h={400}>
      <Stack align="center" spacing="md" style={{ maxWidth: 500 }}>
        <div style={{ color: '#CED4DA' }}>{getIcon()}</div>
        <Title order={2} align="center" size="h3">
          {title}
        </Title>
        <Text color="dimmed" size="sm" align="center">
          {description}
        </Text>
        {action && (
          <Button
            variant="light"
            leftIcon={action.icon}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        )}
      </Stack>
    </Center>
  );
}

